export interface CookieOptions {
  maxAge?: number; // seconds
  expires?: Date;
  path?: string;
  domain?: string;
  secure?: boolean;
  httpOnly?: boolean;
  sameSite?: 'strict' | 'lax' | 'none';
}

export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  if (match) {
    return match[2];
  }
  return null;
}

export function getCookies(): Record<string, string> {
  const cookies: Record<string, string> = {};
  const cookieString = document.cookie;

  if (!cookieString) {
    return cookies;
  }

  cookieString.split(';').forEach((cookie) => {
    const [name, ...valueParts] = cookie.split('=');
    const trimmedName = name.trim();
    const value = valueParts.join('=').trim(); // Handle values with '=' in them

    if (trimmedName) {
      cookies[decodeURIComponent(trimmedName)] = decodeURIComponent(value);
    }
  });

  return cookies;
}

export function hasCookie(name: string): boolean {
  return getCookie(name) !== null;
}

export function setCookie(name: string, value: string, options: CookieOptions = {}): void {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (options.maxAge !== undefined) {
    cookieString += `; max-age=${options.maxAge}`;
  }

  if (options.expires) {
    cookieString += `; expires=${options.expires.toUTCString()}`;
  }

  if (options.path) {
    cookieString += `; path=${options.path}`;
  } else {
    cookieString += '; path=/'; // Default to root path
  }

  if (options.domain) {
    cookieString += `; domain=${options.domain}`;
  }

  if (options.secure) {
    cookieString += '; secure';
  }

  if (options.sameSite) {
    cookieString += `; samesite=${options.sameSite}`;
  }

  // Note: httpOnly cannot be set via client-side JavaScript
  document.cookie = cookieString;
}

export function deleteCookie(name: string, options: Omit<CookieOptions, 'maxAge' | 'expires'> = {}): void {
  setCookie(name, '', {
    ...options,
    maxAge: -1
  });
}
